module.exports = __webpack_public_path__ + "6bc9318b362266b36e54008618640bf0.png";